import { checkUserLimit } from "../../../utils/planLimits";
import PlanLimitBanner from "../../../components/ui/PlanLimitBanner";
import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ConfirmAddPersonnel from "../../../ui/ConfirmAddPersonnel";
import SocieteAndUserService from "../../../services/societeAndUser";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { PermCameraMic } from "@material-ui/icons";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
    zIndex: 9999 
  }),
};
const AddPersonnel = () => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [personalName, setPersonalName] = useState("");
  const [isCancel, setIsCancel] = useState(false);
  const [personalSociete, setPersonalSociete] = useState("");
  const [showLocalisationAndTruck, setShowLocalisationAndTruck] =
    useState(true);
  const [selectedOption, setSelectedOption] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [personalPrenom, setPersonalPrenom] = useState("");
  const [personalCIN, setPersonalCIN] = useState("");
  const [personalLocalisation, setPersonalLocalisation] = useState("");
  const [personalCamion, setPersonalCamion] = useState("");
  const [personalPassword, setPersonalPassword] = useState("");
  const [personalRePassword, setPersonalRePassword] = useState("");
  const [personalEmail, setPersonalEmail] = useState("");
  const [personalPhoneNumber, setPersonalPhoneNumber] = useState("");
  const displayLocalisation = useRef(null);
  const displayCamion = useRef(null);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [onConfirmAddPersonnel, setOnConfirmAddPersonnel] = useState(false);
  const [confirmPersonnelModel, setConfirmPersonnelModel] = useState();
  const animatedComponents = makeAnimated();

  useEffect(() => {
    SocieteAndUserService.getAllRoles()
      .then((response) => {
        if (Object.keys(response.data)[0] === "Role") {
          let roleData = [];
          response.data.Role.forEach((element) => {
            if (element.name !== "SUPER_ADMIN" && element.name !== "ADMIN" ) {
              roleData.push({
                label: element.nameRoleToClient,
                value: element.id,
              });
            }
          });
          setAllRoles(roleData);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    SocieteAndUserService.getSocieteByIdUser()
      .then((response) => {
        if (Object.keys(response.data)[0] === "Societe") {
          setPersonalSociete(response.data.Societe.id);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  }, []);

  // useEffect(() => {
  //   if (
  //     onConfirmAddPersonnel === false &&
  //     confirmPersonnelModel !== null &&
  //     isCancel === false
  //   ) {
  //     window.location.href = "/AddPersonnel";
  //   }
  // }, [onConfirmAddPersonnel]);

  useEffect(() => {
    let indexTransportor = 0;

    allRoles.forEach((element) => {
      if (element.label === "transporteur") {
        indexTransportor = element.value;
      }
    });

    if (selectedOption.includes(indexTransportor)) {
      displayLocalisation.current.style.display = "block";
      displayCamion.current.style.display = "block";
      setShowLocalisationAndTruck(true);
    } else {
      setShowLocalisationAndTruck(false);
      displayLocalisation.current.style.display = "none";
      displayCamion.current.style.display = "none";
    }
  }, [selectedOption]);

  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangepersonalName = (event) => {
    setPersonalName(event.target.value);
  };

  const onChangePersonalPrenom = (event) => {
    setPersonalPrenom(event.target.value);
  };

  const onChangePersonalCin = (event) => {
    setPersonalCIN(event.target.value);
  };

  const onChangePersonalEmail = (event) => {
    setPersonalEmail(event.target.value);
  };
  const onChangePersonalPhoneNumber = (event) => {
    setPersonalPhoneNumber(event.target.value);
  };

  const onChangePersonalLocalisation = (event) => {
    setPersonalLocalisation(event.target.value);
  };

  const onChangePersonalCamion = (event) => {
    setPersonalCamion(event.target.value);
  };

  const onChangePersonalPassword = (event) => {
    setPersonalPassword(event.target.value);
  };

  const onChangePersonalRePassword = (event) => {
    setPersonalRePassword(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onConfirmedAddPersonnelHandler = async () => {
    const limit = await checkUserLimit(1);
    if (!limit.allowed) {
      setErrorAlertText(limit.message);
      setOpenErrorAlert(true);
      return;
    }
    confirmAddPersonnel();
  };
  const confirmAddPersonnel = () => {
    if (personalPassword === "") {
      setErrorAlertText("Erreur :le champ mot de passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword === "") {
      setErrorAlertText("Erreur :le champ confirmer mot passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword !== personalPassword) {
      setErrorAlertText("Erreur : mot de passe non confirmé ! ");
      setOpenErrorAlert(true);
    } else if (personalRePassword === "") {
      setErrorAlertText("Erreur :le champ confirmer mot passe est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalName === "") {
      setErrorAlertText("Erreur :le champ nom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPrenom === "") {
      setErrorAlertText("Erreur :le champ prénom  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalCIN === "") {
      setErrorAlertText("Erreur :le champ CIN  est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalEmail === "") {
      setErrorAlertText("Erreur :le champ email est vide ! ");
      setOpenErrorAlert(true);
    } else if (personalPhoneNumber === "") {
      setErrorAlertText("Erreur :le champ télephone est vide ! ");
      setOpenErrorAlert(true);
    } else if (selectedOption.length === 0) {
      setErrorAlertText("Erreur :Aucun role ! ");
      setOpenErrorAlert(true);
    } else if (showLocalisationAndTruck === true) {
      if (personalLocalisation === "") {
        setErrorAlertText("Erreur :le champ localisation est vide ! ");
        setOpenErrorAlert(true);
      } else if (personalCamion === "") {
        setErrorAlertText("Erreur :le champ camion est vide ! ");
        setOpenErrorAlert(true);
      } else {
        let confirmModel = {
          nom: personalName,
          prenom: personalPrenom,
          cin: personalCIN,
          email: personalEmail,
          numPhone: personalPhoneNumber,
          idSociete: personalSociete,
          idUserCreation: getCurrentUserId(),
          mdp: personalPassword,
          remdp: personalPassword,
          file: file,
          localisation: personalLocalisation,
          camion: personalCamion,
        };

        let roleArray = [];

        selectedOption.forEach((element) => {
          roleArray.push(element.toString());
        });

        confirmModel.roleIds = roleArray;
        if (confirmPersonnelModel.localisation !== "") {
          confirmModel.localisation = confirmPersonnelModel.localisation;
          confirmModel.truck = confirmPersonnelModel.camion;
        }
        console.log("UserRegisterModel", confirmModel);

        if (confirmPersonnelModel.file != null) {
          const uploadData = new FormData();
          uploadData.append("picture", confirmPersonnelModel.file);
          let emailExist = false;

          UploadAndDownloadService.uploadFile(
            "/retail/uploadFile/uploadFile/UserPicture",
            uploadData
          )
            .then((response) => {
              if (Object.keys(response.data)[0] === "success") {
                confirmModel.fileUrl = response.data.success;
                // SocieteAndUserService.addAdminClient(user)
                //   .then((response) => {
                //     if (Object.keys(response.data)[0] === "success") {
                //       setOpenAlert(true);
                //       setIsCancel(false);
                //     } else if (Object.keys(response.data)[0] === "errorExist") {
                //       setOpenInfoAlert(true);
                //       setInfoAlertText("Info :Email déja exist");
                //       emailExist = true;
                //     }
                //   })
                //   .catch(() => {
                //     setOpenErrorAlert(true);
                //     setErrorAlertText(
                //       "Erreur : il ya un probléme de connection"
                //     );
                //   });
                // if (openAlert == true && emailExist == false) {
                //   setIsCancel(false);
                //   setTimeout(setOnConfirmAddPersonnel(false), 1000);
                // }
                //  setMyProductModel(productModel);
              } else {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : il ya un erreur  ");
              }
            })
            .catch(() => {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un probléme de connection");
            });
        }

        // setConfirmPersonnelModel(confirmModel);
        // setOnConfirmAddPersonnel(true);
      }
    }  else {
      let confirmModel = {
        nom: personalName,
        prenom: personalPrenom,
        cin: personalCIN,
        email: personalEmail,
        numPhone: personalPhoneNumber,
        idSociete: personalSociete,
        idUserCreation: 0,
        mdp: personalPassword,
        remdp: personalRePassword,
        file: file,
        localisation: "",
        camion: "",
      };
      console.log(confirmModel);

      let roleArray = [];

      selectedOption.forEach((element) => {
        roleArray.push(element.toString());
      });

      confirmModel.roleIds = roleArray;
      console.log(confirmModel);

      setConfirmPersonnelModel(confirmModel);
      setOnConfirmAddPersonnel(true);
    }
  };

  const onChangeSelectedRole = (e) => {
    setSelectedOption(Array.isArray(e) ? e.map((x) => x.value) : []);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter personnel</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <PlanLimitBanner kind="users" />
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un personnel</h5>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">Nom</label>
                        <input
                          placeholder="Ajouter Nom "
                          onChange={onChangepersonalName}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">Prénom</label>
                        <input
                          placeholder="Ajouter prénom "
                          onChange={onChangePersonalPrenom}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">CIN</label>
                        <input
                          placeholder="Ajouter CIN "
                          onChange={onChangePersonalCin}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">Télephone</label>
                        <input
                          placeholder="Ajouter Télephone"
                          onChange={onChangePersonalPhoneNumber}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">Email</label>
                        <input
                          placeholder="Ajouter email "
                          onChange={onChangePersonalEmail}
                          type="email"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">Mot de passe</label>
                        <input
                          placeholder="Ajouter mot de passe"
                          onChange={onChangePersonalPassword}
                          type="password"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="inputName">
                          Confirmez le mot de passe
                        </label>
                        <input
                          placeholder="Ajouter mot de passe "
                          onChange={onChangePersonalRePassword}
                          type="password"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label>Choisir un ou plusieurs roles </label>
                        <Select
                        
                          styles={styles}
                          isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          // defaultValue={selectedOptionWarehouseManager}
                          onChange={onChangeSelectedRole}
                          options={allRoles}
                          placeholder={ allRoles.length > 0 ? "Choisir " : "Vide"}
                        />
                        {/* <Select
                          className="dropdown"
                          options={allRoles}
                          value={allRoles.filter((obj) =>
                            selectedOption.includes(obj.value)
                          )}
                          onChange={onChangeSelectedRole}
                          placeholder={
                            allRoles.length > 0 ? "Choisir " : "Vide"
                          }
                          menuPlacement="top"
                          isMulti
                          isClearable
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group" ref={displayLocalisation}>
                        <label htmlFor="inputName">Localisation</label>
                        <input
                          placeholder="Ajouter localisation "
                          onChange={onChangePersonalLocalisation}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group" ref={displayCamion}>
                        <label htmlFor="inputName">Camion</label>
                        <input
                          placeholder="Ajouter camion "
                          onChange={onChangePersonalCamion}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div className="form-group" class="col-sm-6">
                      <div
                        class="input-group mb-3 px-2 py-2   sm-white border"
                        style={{ marginTop: 100 }}
                      >
                        <input
                          id="upload"
                          type="file"
                          accept=".jpg, .jpeg, .png"
                          className="form-control border-0"
                          onChange={onUploadImageHandler}
                        />

                        <label
                          id="upload-label"
                          for="upload"
                          class="font-weight-light text-muted"
                        >
                          {fileName}
                        </label>
                        <div class="input-group-append">
                          <label
                            for="upload"
                            class="btn btn-light m-0 rounded-pill px-4"
                          >
                            {" "}
                            <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                            <small class="text-uppercase font-weight-bold text-muted">
                              Choisir une image
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group" class="col-sm-6">
                     
                      <div
                        class="image-area mt-4"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        {fileDataURL ? (
                          <img
                            id="imageResult"
                            src={fileDataURL}
                            alt
                            style={{ height: 197, width: 620 }}
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        ) : (
                          <img
                            style={{ marginTop: 180 }}
                            id="imageResult"
                            src="#"
                            alt
                            className="img-fluid rounded shadow-sm mx-auto d-block"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmedAddPersonnelHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>

      {onConfirmAddPersonnel && (
        <ConfirmAddPersonnel
          setOnConfirmAddPersonnel={setOnConfirmAddPersonnel}
          confirmPersonnelModel={confirmPersonnelModel}
          setIsCancel={setIsCancel}
        />
      )}
    </div>
  );
};
export default AddPersonnel;
